import React, { useEffect, useState } from 'react'
import { fechaActual } from '../../../hooks/UseDate'
import { postHonorarioContratoPortafolio, postHonorariosCrearProcedimiento, postProcedimientoObtenerPTCodi, postProcediminetoBuscarForLiqCod } from '../../../services/PaginaRuta'
import TablaModificarHonorariosProcedimiento from './TablaModificarHonorariosProcedimiento'
import Loading from '../../Loading'
import ModalValidarProcedimientoCirugia from './ModalValidarProcedimientoCirugia'

const ModalModificarSeleccionHonorariosCirujano = ({setmodalOnModificarHonorariosCirujano, passModificarHonorarios,item,user}) => {
  const [dataHonorarios, setDataHonorarios]=useState([])
  const [loading, setloading]=useState(true)
  const [modalOnValidarHonorario, setmodalOnValidarHonorario]=useState(false)
  const [mensajeValidarHonorario, setmensajeValidarHonorario]=useState('')
    const passMoHonorarios=(data)=>{
      passModificarHonorarios(data)
      setmodalOnModificarHonorariosCirujano(false)
    }

    const handleCancelarClick=()=>{
        setmodalOnModificarHonorariosCirujano(false)
    }

    useEffect(()=>{
      console.log(item,'honorarios medico')
      console.log(user,'data user')
      
      setloading(false)     

      const dataPortafolio={
        "ProCirCod": user.ProCirCod,
        "MEPPVig": `${fechaActual()} 00:00:00` ,
        "PRCODI":item.CrgCod
    }
    postHonorarioContratoPortafolio(dataPortafolio).then((res)=>{
      setloading(true)
      if(Array.isArray(res.data)){
        setDataHonorarios(res.data)
      }else{
        if(res.data.error){
          setmensajeValidarHonorario(res.data.error)
        }else{
          setmensajeValidarHonorario('')
        }
        setmodalOnValidarHonorario(true)
        setDataHonorarios([])
      }
    })
      
    },[])

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Selección de Honorarios Cirujano
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>

          <div className="flex-auto overflow-y-auto relative p-4">
            
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-1 inline-block min-w-full sm:px-1 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Código Honorario
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Descripción Honorario
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          loading?
                          dataHonorarios.map((item,index)=>(
                            <TablaModificarHonorariosProcedimiento key={index} item={item} passMoHonorarios={passMoHonorarios}/>
                          ))
                          :
                          <tr>
                            <td></td>
                            <td></td>
                            <td><Loading/></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            
          </div>
        </div>
      </div>
      {modalOnValidarHonorario? <ModalValidarProcedimientoCirugia mensajeValidarHonorario={mensajeValidarHonorario} setmodalOnValidarHonorario={setmodalOnValidarHonorario}/>:null}
    </div>
  )
}

export default ModalModificarSeleccionHonorariosCirujano